const ACTION_PATH = 'app/aspectos'

export const CALL_ATUALIZAR_ASPECTOS = `${ACTION_PATH}/CALL_ATUALIZAR_ASPECTOS`

export const callAtualizarAspecto = (payload) => ({
  type: CALL_ATUALIZAR_ASPECTOS,
  payload,
})
